import * as yup from 'yup';
import { STATUS_CHOICES } from './incomeUtils';

const CURRENCY_CHOICES = ['PKR', 'USD', 'AED', 'EUR', 'GBP'];

export const incomeValidationSchema = yup.object({
  name: yup.string().trim().required('Income name is required').min(2, 'Income name must be at least 2 characters'),
  amount: yup
    .number()
    .required('Amount is required')
    .positive('Amount must be a positive number')
    .typeError('Amount must be a valid number'),
  category: yup.string().required('Category is required'),
  currency: yup.string().required('Currency is required').oneOf(CURRENCY_CHOICES, 'Invalid currency selected'),
  date: yup.date().required('Date is required').nullable().typeError('Invalid date format'),
  status: yup.string().required('Status is required').oneOf(STATUS_CHOICES, 'Invalid status selected'),
  remarks: yup.string().trim().max(500, 'Remarks must be less than 500 characters'),
});